export default __webpack_public_path__ + "static/media/A3.4c2f14e1.mp3";